import { Button, Col, Form, Input, Layout, Row, Space, message } from "antd";
import { Content } from "antd/es/layout/layout";
import React from "react";
import "./style.css";
import CONSTANTS from "constants/constants";
import contactUs from "assets/contact_us.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const ContactUs = () => {
  const { CONTACT_US } = CONSTANTS;
  const { TextArea } = Input;
  const location = { latitude: 12.913318, longitude: 77.595212 };

  const [messageApi, contextHolder] = message.useMessage();
  const success = () => {
    messageApi.open({
      type: "success",
      content: "Form submitted successfully",
    });
  };
  const error = () => {
    messageApi.open({
      type: "error",
      content: "Error while submitting form",
    });
  };

  return (
    <Layout>
      {contextHolder}
      <Content>
        <Row
          className="contact-us-section contact-us-main pr4 pl4 pb2 pt2"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={12}>
            <p className="contact-us-section-header mt1">
              Contact<span className="contact-us-special-text"> Us</span>
            </p>
            <p className="contact-us-section-text">{CONTACT_US.CONTACT_US_1}</p>
          </Col>
          <Col lg={12} className="flex-center">
            <img
              src={contactUs}
              className="contact-us-image"
              alt="contact us"
            />
          </Col>
        </Row>
        <Row
          className="pr4 pl4 pb2 pt2 contact-us-main"
          justify="space-around"
          align="middle"
        >
          <Col lg={24}>
            <Row justify="space-around">
              <p className="contact-us-section-header mt1">
                <span className="contact-us-special-text">Contact</span> Us
              </p>
            </Row>
            <Row justify="space-around" className="mb1">
              <p className="contact-us-form-text mt0">{CONTACT_US.FORM_TEXT}</p>
            </Row>
            <Row gutter={[32, 16]} justify="center">
              <Col lg={9}>
                <Form
                  name="contact us"
                  onFinish={success}
                  onFinishFailed={error}
                  autoComplete="off"
                  className="contact-us-form"
                >
                  <Form.Item name="name">
                    <Input placeholder="Your Name" />
                  </Form.Item>
                  <Form.Item name="email">
                    <Input placeholder="Your Email" />
                  </Form.Item>
                  <Form.Item name="phone">
                    <Input placeholder="Your Phone" />
                  </Form.Item>
                  <Form.Item>
                    <TextArea rows={4} placeholder="Comments/Notes" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      className="contact-us-form-btn"
                    >
                      {CONTACT_US.SEND_MESSAGE}
                    </Button>
                  </Form.Item>
                </Form>
              </Col>
              <Col lg={6} className="contact-us-form-details">
                <Space
                  direction="vertical"
                  size={36}
                  className="contact-us-form-space w100"
                >
                  <div>
                    <Input
                      prefix={<FontAwesomeIcon icon={faLocationDot} />}
                      defaultValue={CONTACT_US.FORM_ADDRESS}
                      className="contact-us-form-details-input"
                    />
                  </div>
                  <div>
                    <Input
                      prefix={<FontAwesomeIcon icon={faEnvelope} />}
                      defaultValue={CONTACT_US.FORM_EMAIL}
                      className="contact-us-form-details-input"
                    />
                  </div>
                  <div>
                    <Input
                      prefix={<FontAwesomeIcon icon={faPhone} />}
                      defaultValue={CONTACT_US.FORM_PHONE}
                      className="contact-us-form-details-input"
                    />
                  </div>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <iframe
              title="google-map"
              src={`https://maps.google.com/maps?q=${location.latitude},${location.longitude}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
              frameBorder="0"
              scrolling="no"
              className="contact-us-map"
            ></iframe>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default ContactUs;
